import FileLoaderService from './fileLoaderService';
import { DicomMetadataStore } from '@ohif/core';

import JSZip from 'jszip';

const processFile = async (file, index, array, updateProgress) => {
  console.log(
    '🚀 ~ file: filesToStudies.js:7 ~ processFile ~ array:',
    array.length
  );
  console.log('🚀 ~ file: filesToStudies.js:7 ~ processFile ~ index:', index);
  // console.log("🚀 ~ file: filesToStudies.js:7 ~ processFile ~ index:", index)
  try {
    console.log('file -->', file);
    const fileLoaderService = new FileLoaderService(file);
    const imageId = fileLoaderService.addFile(file);
    const image = await fileLoaderService.loadFile(file, imageId);
    const dicomJSONDataset = await fileLoaderService.getDataset(image, imageId);

    DicomMetadataStore.addInstance(dicomJSONDataset);

    updateProgress({ actualProgress: index, loaded: 0, total: array.length });
  } catch (error) {
    console.log(
      error.name,
      ':Error when trying to load and process local files:',
      error.message
    );
  }
};

export default async function filesToStudies(files, updateProgress) {
  if (files[0].type.includes('zip') || files[0].type.includes('octet-stream')) {
    let resultDecompress = await decompressZip(files[0]);

    files = resultDecompress;

    console.log(files);
  }

  // files.forEach(element => {
  //   if (element) {

  //   }
  // });

  const processFilesPromises = files.map((file, index, array) =>
    processFile(file, index, array, updateProgress)
  );

  await Promise.all(processFilesPromises);

  return DicomMetadataStore.getStudyInstanceUIDs();
}

/**
 * Decompresses a zip file.
 *
 * @param {File} zipFile - The zip file to decompress.
 * @return {Promise<File[]>} An array of extracted files.
 */
async function decompressZip(zipFile) {
  const zip = new JSZip();
  const extractedFiles = [];

  try {
    const zipData = await zip.loadAsync(zipFile); // Charger le fichier zip

    const allPromises = [];
    zipData.forEach((relativePath, zipEntry) => {
      if (!zipEntry.dir) {
        const promise = zipEntry.async('blob').then(fileData => {
          // Obtenir le contenu du fichier
          const file = new File([fileData], zipEntry.name); // Créer un nouvel objet File
          extractedFiles.push(file);
        });
        allPromises.push(promise);
      }
    });

    await Promise.all(allPromises);
    return extractedFiles;
  } catch (error) {
    console.error(error);
    return [];
    // throw error;
  }
}
